import { useState } from 'react';
import SideNav from '../../../shared/components/SideNav';

import { getPAJAJ010 } from '../../../services/Api';

const PAJAA020 = ({ onAuthenticate }) => {
    const [authPass, setAuthPass] = useState('');

    const handleInputChange = (e) => {
        const { value, name } = e.target;
        if (name === 'authPass') setAuthPass(value);
    };

    const handleSave = async () => {
        const payload = {
            authPass,
        };
        if (authPass === '') {
            window.alert('비밀번호를 입력해 주세요.');
            return;
        }

        try {
            const response = await getPAJAJ010({ params: payload });
            if (response?.data === 'matched') {
                sessionStorage.setItem('authPassVerified', 'true');
                onAuthenticate(true);
            } else if (response?.data === 'mismatched') {
                window.alert('비밀번호가 일치하지 않습니다.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="inq">
                        <div className="inq__block">
                            <p className="inq__desc mb24">※ 2차 비밀번호를 입력해 주세요.</p>
                            <input
                                type="password"
                                name="authPass"
                                className="inq__input"
                                placeholder="비밀번호 입력"
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                            />
                            <button type="button" className="inq__btn" onClick={handleSave}>
                                확인
                            </button>
                            <p className="inq__desc mt46">
                                ※ 2차 비밀번호는 조회권한 설정에서 등록하신 비밀번호입니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAJAA020;
